import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const RevenueIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="7" stroke="#2E7D32" strokeWidth="1.5" fill="none" />
      <path
        d="M8 3.5V4.5M8 11.5V12.5M9.5 6C9.5 5.17 8.83 4.5 8 4.5C7.17 4.5 6.5 5.17 6.5 6C6.5 6.83 7.17 7.5 8 7.5H8.5C9.33 7.5 10 8.17 10 9C10 9.83 9.33 10.5 8.5 10.5H8C7.17 10.5 6.5 9.83 6.5 9"
        stroke="#2E7D32"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
